import { RedoBaseModal } from "@redotech/redo-web/arbiter-components/modal/redo-base-modal";
import {
  RedoModalFooter,
  RedoModalHeader,
} from "@redotech/redo-web/arbiter-components/modal/redo-modal";
import { Flex } from "@redotech/redo-web/flex";
import { memo } from "react";
import { OnboardingProps } from "../common";
import * as styles from "./dhl-free-labels-announcement-modal.module.css";

const CHECK_ELIGIBILITY_URL =
  "http://meet.redo.com/e3t/Ctc/UC+113/d2G8Yr04/VVQTJb1wJbwHW3WCsW06L8KG7W8_npSB5SRk1fN97h0HT3lYM-W95jsWP6lZ3mTW2nZhp94JwjZ_W4M41KT5GD5K0W8dY4Tg3DnvtYW4bGShv1kLH8WW42y1QH1ZTFKqW6gT-jM7KTZW-W4b0xPB16Fbt8W79GnVz1lPQSfW2Xh0bK1KCjZ5W5r5T8Y6R-ghzW4jNNdx6L3jvtN58RHVvV_YCNN5KkJHfDRx_9N4XmpsxrsPZ1W91n_lQ5dJ1y5W64r9844yjgDcW26JDp812cvSCW8p1CBQ67zSXWW1N3tHr6VGq4kW1TGvYQ2_W5cXW7nPG7F8M7rPMW7vVRv_6wRps3W380_M67QhnjRW8-kP_B79WbrdN3bzl1j6sDn_W1cSY7J8N95tgW1_hy3L22jh4qV_ZJgx8R-kv0W92WlkN5HgRjwN70s9Bl972G0dSX8pb04";
const DHL_FREE_LABELS_ANNOUNCEMENT_IMAGE_URL =
  "https://assets.getredo.com/dhl/dhl-free-labels-announcement.jpg";

const heroImageProps = {
  alt: "Shipping labels ready for fulfillment",
  src: DHL_FREE_LABELS_ANNOUNCEMENT_IMAGE_URL,
};

export const DhlFreeLabelsAnnouncementModal = memo(
  function DhlFreeLabelsAnnouncementModal({
    handleComplete,
    handleDismiss,
  }: OnboardingProps) {
    const checkEligibility = async () => {
      window.open(CHECK_ELIGIBILITY_URL, "_blank", "noopener,noreferrer");
      await handleComplete();
    };

    return (
      <RedoBaseModal
        darkMode
        isOpen
        onModalCloseRequested={handleDismiss}
        otherClasses={[styles.modal]}
      >
        <Flex pt="3xl" px="3xl">
          <Flex
            {...heroImageProps}
            as="img"
            borderRadius="sm"
            className={styles.heroImage}
            w="full"
          />
        </Flex>
        <RedoModalHeader
          cancelClicked={handleDismiss}
          hideCloseButton
          subtitle={
            <>
              Go live with Redo&apos;s DHL eCommerce rates this month, and
              we&apos;ll cover one full business day of shipping labels, up to
              $2,000.
              <br />
              <br />
              After your free shipping day, save $0.30 on every shipment with
              Redo&apos;s negotiated DHL rates.
              <br />
              <br />
              DHL eCommerce Expedited also includes:
              <br />• 2–5 day ground or air delivery, comparable to UPS Ground
              <br />• Daily pickup or a schedule that works for you
              <br />• Gaylords and bags delivered weekly or biweekly
            </>
          }
          title="One free day of shipping labels"
        />
        <RedoModalFooter
          primaryButton={{
            onClick: checkEligibility,
            size: "sm",
            text: "Check eligibility",
            theme: "action",
          }}
          secondaryButton={{
            onClick: handleDismiss,
            size: "sm",
            text: "Dismiss",
          }}
        />
      </RedoBaseModal>
    );
  },
);
